import { ReactElement } from 'react';
import { useTheme } from '@mui/material';
import { AreaProps } from 'recharts';

import { CHART_HEIGHT } from '../const';

export function Cursor(props: AreaProps): ReactElement {
  const { points } = props;
  const { palette } = useTheme();
  const x = points?.[0]?.x;

  return (
    <svg>
      <line
        stroke={palette.primary.main}
        strokeWidth={2}
        x1={x}
        x2={x}
        y1={0}
        y2={CHART_HEIGHT - 28}
      />
    </svg>
  );
}
